import Header from "../../Header";
import Footer from "../../Footer";
import MessageLink from "../../MessageLink";
import CorpoNoticia from "../../Postagens/Noticias/CorpoNoticia";
import Lgpd from "../../Lgpd";
import NoticiaDetalhes from "../../NoticiaDetalhes";
import ErrorBoundary from "../../ErrorHandler/ErrorBoundary";
import { Detalhes } from "./Detalhes";

const NoticiaCompletaRender = (props: any) => {
  
    return (
		<>

		<ErrorBoundary><Header/></ErrorBoundary>
		{/* <ErrorBoundary><NoticiaDetalhes/></ErrorBoundary>
		<ErrorBoundary><CorpoNoticia /></ErrorBoundary> */}
		<Detalhes></Detalhes>
		<ErrorBoundary><Footer/></ErrorBoundary>
		<ErrorBoundary><MessageLink/></ErrorBoundary>
		<ErrorBoundary><Lgpd /></ErrorBoundary>

		</>
    )
};

export default NoticiaCompletaRender;

 
